import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c3874c7")

_pushScopeId("data-v-5c3874c7")
const _hoisted_1 = { class: "form-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      "label-width": "80px",
      class: "width500px",
      "label-position": _ctx.$formLabelPosition
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.ProperAllTextIDCardVerification
        }, {
          default: _withId(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.formData.IDCardVerification,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.IDCardVerification = $event)),
              "active-text": _ctx.$wordList.ProperAllTextOn,
              "inactive-text": _ctx.$wordList.ProperAllTextOff,
              "active-value": 1,
              "inactive-value": 0,
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            }, null, 8, ["modelValue", "active-text", "inactive-text"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.ProperAllTextFaceEnrollment
        }, {
          default: _withId(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.formData.FaceEnrollment,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.FaceEnrollment = $event)),
              "active-text": _ctx.$wordList.ProperAllTextOn,
              "inactive-text": _ctx.$wordList.ProperAllTextOff,
              "active-value": 1,
              "inactive-value": 0,
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            }, null, 8, ["modelValue", "active-text", "inactive-text"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "label-position"]),
    _createVNode(_component_cus_button, {
      type: "blue",
      onClick: _ctx.submit
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})